import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    examListLoading: false,
    examListSuccess: null,
    examListError: '',
    getExamLoading: false,
    getExamSuccess: {},
    getExamError: '',
}

export const examCalendarSlice = createSlice({
    name: 'exam-calendar',
    initialState,
    reducers: {
        setExamListLoading: (state, action) => {
            state.examListLoading = true;
            state.examListSuccess = null;
            state.examListError = '';
        },
        setExamListSuccess: (state, action) => {
            state.examListLoading = false;
            state.examListSuccess = action.payload;
            state.examListError = '';
        },
        setExamListError: (state, action) => {
            state.examListLoading = false;
            state.examListSuccess = null;
            state.examListError = action.payload;
        },
        setGetExamLoading: (state) => {
            state.getExamLoading = true;
            state.getExamSuccess = {};
            state.getExamError = '';
        },
        setGetExamSuccess: (state, action) => {
            state.getExamLoading = false;
            state.getExamSuccess = action.payload;
            state.getExamError = '';
        },
        setGetExamError: (state, action) => {
            state.getExamLoading = false;
            state.getExamSuccess = {};
            state.getExamError = action.payload;
        },
        resetDetails: (state, action) => {
            state.getExamSuccess = {};
        },
    },
})

export const {
    setExamListLoading, setExamListSuccess, setExamListError,
    // setDocumentsListLoading, setDocumentsListSuccess, setDocumentsListError,
    setGetExamLoading, setGetExamSuccess, setGetExamError,
    resetDetails
} = examCalendarSlice.actions

export default examCalendarSlice.reducer;